<section class="operational-history" [class.compact]="compact">
  <div *ngIf="loading" class="history-skeleton">
    <p-skeleton *ngFor="let item of [1, 2, 3]" height="92px" borderRadius="12px"></p-skeleton>
  </div>

  <ng-container *ngIf="!loading">
    <div *ngIf="items.length" class="history-overview">
      <span><b>{{ items.length }}</b><small>Ocorrências</small></span>
      <span><b>{{ totalAbertas }}</b><small>Em aberto</small></span>
      <span><b>{{ totalCriticas }}</b><small>Alta prioridade</small></span>
      <span><b>{{ totalRondas }}</b><small>Rondas</small></span>
    </div>

    <div *ngIf="items.length" class="occurrence-list">
      <article *ngFor="let item of items; trackBy: trackItem" class="occurrence-card"
        [ngClass]="getCriticidadeClass(item)">
        <span class="severity-rail"></span>

        <div class="occurrence-head">
          <span class="occurrence-icon">
            <hugeicons-icon *ngIf="occurrenceHugeIcon; else defaultOccurrenceIcon" [icon]="occurrenceHugeIcon" [size]="16"></hugeicons-icon>
            <ng-template #defaultOccurrenceIcon><i class="ri-alarm-warning-line"></i></ng-template>
          </span>
          <div class="occurrence-title">
            <div>
              <strong>{{ getTipo(item) }}</strong>
              <span class="occurrence-id">#{{ item.id }}</span>
            </div>
            <small><i class="ri-time-line"></i>{{ formatarData(item.dataOcorrencia) }}</small>
          </div>
          <span class="severity-pill" [ngClass]="getCriticidadeClass(item)">
            {{ getCriticidade(item) }}
          </span>
          <span class="state-pill" [ngClass]="getEstadoClass(item)">{{ item.estado || 'Aberta' }}</span>
        </div>

        <p class="occurrence-description">{{ getDescricao(item) }}</p>

        <div *ngIf="item.rondaId || item.ronda" class="round-context">
          <span class="round-icon"><i class="ri-route-line"></i></span>
          <div>
            <small>RONDA {{ item.rondaId ? '#' + item.rondaId : '' }}</small>
            <strong>{{ getRondaPeriodo(item) }}</strong>
          </div>
          <span *ngIf="getRondaDuracao(item)" class="round-duration">{{ getRondaDuracao(item) }}</span>
          <span *ngIf="!item.ronda?.dataFim" class="round-live"><i></i> Em curso</span>
        </div>

        <p *ngIf="item.ronda?.observacao" class="round-note">
          <i class="ri-sticky-note-line"></i>{{ item.ronda.observacao }}
        </p>

        <div *ngIf="getImagens(item).length" class="occurrence-gallery">
          <button *ngFor="let imagem of getImagens(item); let first = first" type="button"
            class="gallery-thumb" (click)="abrirImagem(imagem, item)"
            [pTooltip]="'Ver fotografia da ocorrência #' + item.id" tooltipPosition="top">
            <img [src]="imagem" [alt]="'Fotografia da ocorrência ' + item.id" loading="lazy" />
            <span *ngIf="first && getImagens(item).length > 1">+{{ getImagens(item).length - 1 }}</span>
          </button>
        </div>
        <div *ngIf="!getImagens(item).length" class="no-evidence">
          <i class="ri-image-line"></i> Sem evidência fotográfica
        </div>
      </article>
    </div>

    <div *ngIf="!items.length" class="history-empty">
      <span>
        <hugeicons-icon *ngIf="emptyStateHugeIcon; else defaultEmptyIcon" [icon]="emptyStateHugeIcon" [size]="18"></hugeicons-icon>
        <ng-template #defaultEmptyIcon><i class="ri-shield-check-line"></i></ng-template>
      </span>
      <strong>Sem ocorrências registadas</strong>
      <p>{{ emptyText }}</p>
    </div>
  </ng-container>
</section>

<p-dialog [(visible)]="imagemVisible" [modal]="true" [dismissableMask]="true"
  [style]="{ width: 'min(900px, 94vw)' }" styleClass="evidence-dialog" appendTo="body">
  <ng-template pTemplate="header"><strong>{{ imagemTitulo }}</strong></ng-template>
  <div class="evidence-viewer"><img *ngIf="imagemAberta" [src]="imagemAberta" [alt]="imagemTitulo" /></div>
</p-dialog>
